<template>
  <section id="StatNumbers">
    <div>
      <h3 id="callsMade">{{ data.callsMade.toLocaleString('en-US') }}</h3>
      <p>Calls made</p>
    </div>
    <div>
      <h3 id="messagesSent">{{ data.messagesSent.toLocaleString('en-US') }}</h3>
      <p>Messages sent</p>
    </div>
    <div>
      <h3 id="callsIdentified">{{ data.callsIdentified.toLocaleString('en-US') }}</h3>
      <p>Calls identified</p>
    </div>
    <div>
      <h3 id="messagesIdentified">{{ data.messagesIdentified.toLocaleString('en-US') }}</h3>
      <p>Messages identified</p>
    </div>
  </section>
</template>

<script>
import { ref, onMounted } from "vue";
import { TweenLite, Power2 } from "gsap";
import ScrollMagic from "scrollmagic";
export default {
  setup() {
    const data = ref({
      callsMade: 49500000000,
      messagesSent: 6700000000,
      callsIdentified: 145400000000,
      messagesIdentified: 13800000000,
    });

    onMounted(() => {
      const controller = new ScrollMagic.Controller();
      [
        "callsMade",
        "messagesSent",
        "callsIdentified",
        "messagesIdentified",
      ].forEach((el) => {
        const counter = { val: 0 };
        const tween = TweenLite.to(counter, 1.25, {
          val: data.value[el],
          roundProps: "val",
          ease: Power2.easeOut,
          paused: true,
          onUpdate: () => (data.value[el] = counter.val),
        });

        new ScrollMagic.Scene({
          triggerElement: `#${el}`,
          offset: (-1 * window.innerHeight) / 2,
          reverse: false,
        })
          .on("start", () => tween.play())
          .addTo(controller);
      });
    });

    return {
      data,
    };
  },
};
</script>

<style>
#StatNumbers {
  justify-content: space-around;
  background-color: var(--green);
  background-image: url("../assets/images/bg-pattern.png");
  background-position: center center;
  background-size: cover;
  padding: 48px 20px;
}
#StatNumbers > div {
  margin: 32px auto;
}
#StatNumbers h3 {
  font-size: 32px;
  line-height: 48px;
  letter-spacing: -1.72px;
}
#StatNumbers p {
  font-family: "Montserrat", sans-serif;
  font-weight: 400;
  font-size: 24px;
  line-height: 32px;
  letter-spacing: -0.65px;
}
@media screen and (min-width: 450px) {
  #StatNumbers h3 {
    font-size: 48px;
    line-height: 61px;
    letter-spacing: -1.72px;
  }
}
@media screen and (min-width: 640px) {
  #StatNumbers h3 {
    font-size: 64px;
    line-height: 91px;
    letter-spacing: -1.72px;
  }
}
@media screen and (min-width: 860px) {
  #StatNumbers > div {
    margin: 48px auto;
  }
  #StatNumbers h3 {
    font-size: 100px;
    line-height: 122px;
    letter-spacing: -3.45px;
  }
  #StatNumbers p {
    font-size: 30px;
    line-height: 37px;
    letter-spacing: -0.75px;
  }
}
</style>